import { mapMutations, mapGetters, mapActions } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "delivery-methods",
    data() {
        return {};
    },
    mixins: [dynamicHead],
    components: {
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({
            deliveryMethodsList: "deliveryMethods/deliveryMethodsList",
            deliveryMethodsListLoading: "deliveryMethods/deliveryMethodsListLoading",
            seoData: "setting/seoData",
        }),
    },
    created() {
        this.getSeoData("delivery-methods").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.deliveryMethodsList) {
            this.fetchDeliveryList();
        }
    },
    methods: {
        ...mapActions({
            fetchDeliveryList: `deliveryMethods/GET_DELIVERY_METHODS_LIST`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
